import { memo, useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "../../../components/IconButton";
import { ModalMessage } from "../../../components/ModalMessage";
import useAppData from "../../../hook/useAppData";
import { IconLogout } from "../../../icons";
import AccessRoutes from "./components/AccessRoutes";
import logo from "../../../image/logoContrastWithName.svg";
import logoSmall from "../../../image/logoContrastWithoutName.svg";
import "./sideBar.component.scss";

function SideBar({ status }: any) {
  const { removeToken, profileId, corporation, corporationId } = useAppData();
  const [accordionSide, setAccordionSide] = useState("");

  const history = useHistory();

  async function logout() {
    await removeToken("token");
    return history.push("/login");
  }

  function redirectToHome() {
    return history.push("/home");
  }

  return (
    <>
      <aside className={`sideBarContainer bg-primary ${status && "mobileHidden"}`}>
        <div className="sideBarContainerLink">
          <div>
            <div className="sideBarLogoContainer">
              {status ? (
                <img onClick={redirectToHome} alt="logo-tegra" className="pointer -ml-2 -mt-5" src={logoSmall} />
              ) : (
                <img onClick={redirectToHome} alt="logo-tegra" className="pointer w-60 h-60 -mb-10 -mt-12" src={logo} />
              )}

              <h1 onClick={redirectToHome} className="pointer ">
                {corporation}
              </h1>
            </div>

            <ul className={`sideBarLinkNav ${!status && "arial-label-hidden"}`}>
              <AccessRoutes status={status} accordionSide={accordionSide} setAccordionSide={setAccordionSide} />
            </ul>
          </div>
          <div className={`${!status ? "logout" : "logoutClosed"}`}>
            <ModalMessage id={0} onClickCancel={() => {}} onClickConfirm={() => {}} status={false} text="Tem certeza?" />
            <ul className={`sideBarLinkNav ${!status && "arial-label-hidden"}`}>
              <IconButton className="menuIconSideBar pointer" icon={IconLogout} onClick={logout} text="Sair" />
            </ul>
          </div>
        </div>
      </aside>
    </>
  );
}

export default memo(SideBar);
